import { render, staticRenderFns } from "./SpecialMatter.vue?vue&type=template&id=26cbdbd6&scoped=true"
import script from "./SpecialMatter.vue?vue&type=script&lang=js"
export * from "./SpecialMatter.vue?vue&type=script&lang=js"
import style0 from "./SpecialMatter.vue?vue&type=style&index=0&id=26cbdbd6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26cbdbd6",
  null
  
)

export default component.exports